import { useEffect, useRef, useState } from 'react';

type UseCountdownProps = {
  nbrOfSeconds: number;
  callback: VoidFunction;
  enable: boolean;
};

export const useCountdown = ({ callback, enable, nbrOfSeconds }: UseCountdownProps) => {
  const countdownRef = useRef<NodeJS.Timeout>();
  const startTimeDateRef = useRef<Date>();

  const [timeLeftInSec, setTimeLeftInSec] = useState(nbrOfSeconds);

  useEffect(() => {
    if (enable) {
      if (startTimeDateRef.current === undefined) {
        startTimeDateRef.current = new Date();
      }

      const id = setInterval(() => {
        const secondsPastSinceStart = Math.floor(
          (new Date().getTime() - (startTimeDateRef.current as Date).getTime()) / 1000
        );

        const secondsLeft = nbrOfSeconds - secondsPastSinceStart;
        if (secondsLeft <= 0) {
          callback();
          if (countdownRef.current) clearInterval(countdownRef.current);
          startTimeDateRef.current = undefined;
        }

        setTimeLeftInSec(secondsLeft);
      }, 1000);

      countdownRef.current = id;
    }

    return () => {
      if (countdownRef.current) clearInterval(countdownRef.current);
    };
  }, [callback, enable, timeLeftInSec, nbrOfSeconds]);

  return timeLeftInSec;
};
